import MetaTags from '@otovo/shared/components/Sanity/MetaTags';
import {
  Sanity$AboutUsDocument,
  Sanity$CampaignPage,
  Sanity$HomePage,
  Sanity$Meta,
  Sanity$PackagePage,
  Sanity$PricingPage,
  Sanity$QuotePage,
  Sanity$Section,
  Sanity$TextBlock,
} from '@otovo/shared/types/sanityTypes';

import { Sanity$Image } from '@otovo/shared/types/sanityImage';
import StructuredDataScripts from '../../Sanity/StructuredDataScripts';
import ContentRowList from '../../SanityLandingPage/ContentRowList';

type Props = {
  renderBeforeRows?: React.ReactNode;
  renderAfterRows?: React.ReactNode;
  contentRows?: Sanity$Section[];
  page:
    | Sanity$HomePage
    | Sanity$PackagePage
    | Sanity$PricingPage
    | Sanity$QuotePage
    | Sanity$CampaignPage
    | Sanity$AboutUsDocument;
  pageTitle: string | Sanity$TextBlock[];
  pageDescription: string | Sanity$TextBlock[];
  pageImage: Sanity$Image;
  children?: React.ReactNode;
};

const SanityPageWrapper = ({
  renderBeforeRows,
  contentRows = [],
  page,
  pageTitle,
  pageDescription,
  pageImage,
  children,
}: Props) => {
  const rowContext = {
    mainHardwareType:
      'mainHardwareType' in page && page.mainHardwareType
        ? page.mainHardwareType
        : 'pv_system',
    version: 'v2025',
  };

  function getMeta(): Sanity$Meta {
    if (!page.meta) {
      return null;
    }

    return {
      ...page.meta,
      canonicalURLOverride: null,
    };
  }

  return (
    <>
      <MetaTags
        meta={getMeta()}
        defaultTags={{
          title: pageTitle,
          description: pageDescription,
          image: pageImage,
        }}
      />
      {!!page.meta?.structuredData && (
        <StructuredDataScripts structuredData={page.meta.structuredData} />
      )}
      {renderBeforeRows}
      {!!contentRows && (
        <div>
          <ContentRowList
            rows={contentRows}
            rowContext={rowContext}
            storefrontV2Enabled
          />
        </div>
      )}
      {children}
    </>
  );
};

export default SanityPageWrapper;
